module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/icon-da3d6049d62ea5e70a5c5e01c476cf05.png";